import { render, staticRenderFns } from "./MypageCurrentPlanSection.vue?vue&type=template&id=cffac738&scoped=true"
import script from "./MypageCurrentPlanSection.vue?vue&type=script&lang=ts"
export * from "./MypageCurrentPlanSection.vue?vue&type=script&lang=ts"
import style0 from "./MypageCurrentPlanSection.vue?vue&type=style&index=0&id=cffac738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffac738",
  null
  
)

export default component.exports